var _circle, _path, _rect, _circle2, _circle3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6668,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3346 22.0118L29.5936 22.0118C28.5157 22.0118 27.6399 21.136 27.6399 20.0582C27.6399 18.9803 28.5157 18.1045 29.5936 18.1045L30.3346 18.1045L30.3346 12.3333L9.00129 12.3333L9.00129 27.7607L30.3346 27.7607L30.3346 22.0118ZM10.4834 13.8153L28.875 13.8153L28.875 16.7121C27.3255 17.0489 26.1803 18.4187 26.1803 20.0581C26.1803 21.6974 27.3255 23.0672 28.875 23.4041L28.875 26.2785L10.4834 26.2785L10.4834 13.8153Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.4427,
    y: 16.1579,
    width: 1.73333,
    height: 9.33333,
    transform: "rotate(45 21.4427 16.1579)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3346,
    cy: 17.6666,
    r: 1.66667,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0013,
    cy: 22.3333,
    r: 1.66667,
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit);
export default __webpack_public_path__ + "static/media/benefit.d8008e4861fd45546b64fcee07b9295e.svg";
export { ForwardRef as ReactComponent };